// components/MobileBottomNav.jsx — Phase F premium 5-item bottom nav.
//
// Items: Ana səhifə / Bazar / Mağazalar / Səbət / Hesab
// Drawer removed — mobile menu is owned by Headers.jsx slide-in.
// Notifications live in the Headers mobile top bar.
//
// Auth gating preserved: Səbət / Hesab redirect to /login when no userInfo.
// Routes verified against App.jsx.

import React, { useEffect } from 'react'
import { useNavigate, useLocation } from 'react-router-dom'
import { useSelector, useDispatch } from 'react-redux'
import { AiFillHome, AiFillShopping } from 'react-icons/ai'
import { FaUser, FaStore, FaShoppingBag } from 'react-icons/fa'
import { fetch_unread_count } from '../store/reducers/notificationReducer'

const ITEMS = [
    { key: 'home',   label: 'Ana səhifə', path: '/',          icon: <AiFillHome    size={20} />, auth: false },
    { key: 'market', label: 'Bazar',      path: '/market',    icon: <FaShoppingBag size={17} />, auth: false },
    { key: 'shops',  label: 'Mağazalar',  path: '/magazalar', icon: <FaStore       size={17} />, auth: false },
    { key: 'cart',   label: 'Səbət',      path: '/card',      icon: <AiFillShopping size={20} />, auth: true  },
    { key: 'account',label: 'Hesab',      path: '/dashboard', icon: <FaUser        size={17} />, auth: true  },
]

// Route-group prefixes so aliases and detail pages keep the right tab
// highlighted (e.g. /bazar or /product/... → Bazar, /shop/:slug → Mağazalar).
const GROUP_PREFIXES = {
    market: ['/market', '/bazar', '/products', '/product', '/search', '/category', '/haftanin-firsatlari'],
    shops:  ['/magazalar', '/shops', '/shop', '/stores'],
}

const isPathActive = (current, target, key) => {
    if (target === '/') return current === '/'
    const prefixes = GROUP_PREFIXES[key] || [target]
    return prefixes.some(p => current === p || current.startsWith(`${p}/`) || current.startsWith(`${p}?`))
}

const MobileBottomNav = () => {
    const navigate = useNavigate()
    const location = useLocation()
    const dispatch = useDispatch()

    const { userInfo } = useSelector(s => s.auth)
    const { card_product_count } = useSelector(s => s.card)

    // Keep the unread-count pre-fetch — Headers will render the bell badge.
    useEffect(() => {
        if (userInfo) dispatch(fetch_unread_count())
    }, [userInfo, dispatch])

    const handleNav = (item) => {
        if (item.auth && !userInfo) {
            navigate('/login')
            return
        }
        navigate(item.path)
    }

    return (
        <nav
            aria-label='Mobil naviqasiya'
            className='fixed inset-x-0 bottom-0 z-[997] hidden md-lg:block border-t border-slate-200 bg-white/95 backdrop-blur shadow-[0_-6px_18px_rgba(15,23,42,0.06)] pb-[env(safe-area-inset-bottom,0)]'
        >
            <ul className='mx-auto flex max-w-marketplace items-stretch px-1'>
                {ITEMS.map((item) => {
                    const active    = isPathActive(location.pathname, item.path, item.key)
                    const showBadge = item.key === 'cart' && card_product_count > 0
                    return (
                        <li key={item.key} className='flex-1'>
                            <button
                                type='button'
                                onClick={() => handleNav(item)}
                                aria-label={item.label}
                                aria-current={active ? 'page' : undefined}
                                className={`flex h-14 w-full flex-col items-center justify-center gap-0.5 text-[11px] font-medium transition-colors ${
                                    active ? 'text-brand-700' : 'text-slate-500 hover:text-slate-700'
                                }`}
                            >
                                <span className='relative inline-flex h-5 items-center justify-center'>
                                    {item.icon}
                                    {showBadge && (
                                        <span className='absolute -right-3 -top-1 inline-flex h-[16px] min-w-[16px] items-center justify-center rounded-pill bg-brand-600 px-1 text-[10px] font-bold text-white'>
                                            {card_product_count > 99 ? '99+' : card_product_count}
                                        </span>
                                    )}
                                </span>
                                <span className={active ? 'font-semibold' : ''}>{item.label}</span>
                            </button>
                        </li>
                    )
                })}
            </ul>
        </nav>
    )
}

export default MobileBottomNav
